import ModelUtil from '@leverege/model-util';
import HistoryModel from "../../shared/renderers/HistoryModel.js";
const TYPE = 'molten.mapRenderer.google.HeatmapModel';
const DEFAULT_COLOR_RANGE = ['#ffffb2', '#fed976', '#feb24c', '#fd8d3c', '#f03b20', '#bd0026'];

/**
 * This represents geo layers that have point objects. It will contain
 * options for the layer as whole, such as visibility options and selection
 * and rollover options.
 */
function create(layerName, name, objectType) {
  return {
    ...HistoryModel.create(layerName, name, objectType),
    type: TYPE,
    blobRadius: 30,
    colorRange: [...DEFAULT_COLOR_RANGE],
    intensity: 1,
    threshold: 0.05,
    aggregation: 'SUM',
    weightsTextureSize: 256
  };
}
export default {
  ...HistoryModel,
  TYPE,
  create,
  DEFAULT_COLOR_RANGE,
  ...ModelUtil.createAllValue('blobRadius'),
  ...ModelUtil.createAllArray('colorRange'),
  ...ModelUtil.createAllValue('intensity'),
  ...ModelUtil.createAllValue('threshold'),
  ...ModelUtil.createAllValue('aggregation'),
  ...ModelUtil.createAllValue('weightsTextureSize')
};